module.exports = __webpack_public_path__ + "img/icon_acc_history.6cbab696.svg";